import { render } from "./SuiviHospitalisation.vue?vue&type=template&id=05334af1&scoped=true"
import script from "./SuiviHospitalisation.vue?vue&type=script&lang=js"
export * from "./SuiviHospitalisation.vue?vue&type=script&lang=js"

import "./SuiviHospitalisation.vue?vue&type=style&index=0&id=05334af1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05334af1"]])

export default __exports__